<template>
  <div id="app" class="flex-center">
    <ul class="flex-center nav">
      <a @click="routerToNZFJ">农庄风景</a>
      <a @click="routerToMS">农家美食</a>
      <a @click="routerToZQYZ">珍禽养殖</a>
      <a @click="routerToYL">娱乐项目</a>
      <a @click="routerToDT">地图</a>
    </ul>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {}
  },
  methods: {
    routerToNZFJ() {
      this.$router.push('nzfj')
    },
    routerToMS() {
        this.$router.push('ms')
    },
    routerToZQYZ() {
        this.$router.push('zqyz')
    },
    routerToYL() {
        this.$router.push('yl')
    },
    routerToDT() {
        this.$router.push('dt')
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue